export default "__VITE_ASSET__mp2$$mq___"